import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

// The one Firebase app: analytics, and Google sign-in. Set
// REACT_APP_AUTH_EMULATOR (e.g. http://127.0.0.1:9099) to sign in against the
// local Auth emulator instead of Google.
const config = {
    apiKey: "AIzaSyDxbgKv9nThMpKYIzv9U7R-JQAXFAUAftA",
    authDomain: "play-sequence.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "play-sequence",
    storageBucket: "play-sequence.appspot.com",
    messagingSenderId: "154367757387",
    appId: "1:154367757387:web:185111808b8235ec9091ce",
    measurementId: "G-0JSK5D2DNH"
};

export const firebaseApp = initializeApp(config);
export const auth = getAuth(firebaseApp);

if (process.env.REACT_APP_AUTH_EMULATOR) {
    connectAuthEmulator(auth, process.env.REACT_APP_AUTH_EMULATOR, { disableWarnings: true });
}
